import React from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { FiAlertTriangle } from 'react-icons/fi';

const SessionTimeoutDialog = ({ isOpen, onLogout }) => {
    return (
        <Dialog
            open={isOpen}
            onClose={() => { }}
            className="fixed inset-0 z-50"
        >
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />

            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
                    <div className="flex items-center gap-4">
                        <div className="flex-shrink-0 p-2 bg-yellow-100 rounded-full">
                            <FiAlertTriangle className="h-6 w-6 text-yellow-600" />
                        </div>
                        <DialogTitle className="text-lg font-medium text-gray-900">
                            Session Timeout Warning
                        </DialogTitle>
                    </div>

                    <Dialog.Description className="mt-4 text-sm text-gray-500">
                        Your session has expired due to inactivity. You will be logged out.
                    </Dialog.Description>

                    <div className="mt-6 flex justify-end gap-3">
                        <button
                            onClick={onLogout}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            OK
                        </button>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export default SessionTimeoutDialog;